module.exports = __webpack_public_path__ + "img/product_banner_jidian.2b0e35cc.png";